// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1HcqJ","errorLogs":"styles_errorLogs__1Rw0m"};